var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin-bg"},[_c('Header'),_c('search-header'),_c('main',[_c('div',{staticClass:"main-content container-md"},[_c('sidebar'),_c('div',{staticClass:"content-msg"},[_c('router-view')],1)],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }